import { render } from "./FullScreenFilePreview.vue?vue&type=template&id=4256e292&scoped=true"
import script from "./FullScreenFilePreview.vue?vue&type=script&lang=js"
export * from "./FullScreenFilePreview.vue?vue&type=script&lang=js"

import "./FullScreenFilePreview.vue?vue&type=style&index=0&id=4256e292&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4256e292"]])

export default __exports__